import {useCallback} from 'react';

import type {User} from 'nutshell-core/users/users-types';

import type {NutFileInput, WidgetFragment as Widget} from 'nutshell-graphql-types';

import {AttachmentsWidget} from '../../../../../core-entity/widgets/attachments-widget/components/attachments-widget';

import {useAddAttachmentToContact} from '../graphql/hooks/use-add-attachment-to-contact';
import {useGetAttachmentsForContact} from '../graphql/hooks/use-get-attachments-for-contact';
import {useRemoveAttachmentFromContact} from '../graphql/hooks/use-remove-attachment-from-contact';

interface Props {
    contactId: string;
    user: User | null | undefined;
    widget: Widget;
}

export function ContactAttachmentsWidget(props: Props) {
    const {contactId, user, widget} = props;

    const {files, isLoading: isLoadingGetAttachments} = useGetAttachmentsForContact(contactId);
    const {addAttachmentToContact} = useAddAttachmentToContact();
    const {removeAttachmentFromContact} = useRemoveAttachmentFromContact();

    const handleRemoveAttachment = useCallback(
        (fileId: string) => removeAttachmentFromContact({contact: contactId, fileId}),
        [contactId, removeAttachmentFromContact]
    );

    const handleAddAttachment = useCallback(
        (filesToAdd: NutFileInput[]) =>
            addAttachmentToContact({contact: contactId, files: filesToAdd}, user, files),
        [addAttachmentToContact, files, contactId, user]
    );

    return (
        <AttachmentsWidget
            user={user}
            entityId={contactId}
            widget={widget}
            files={files}
            isLoadingAttachments={isLoadingGetAttachments}
            onRemoveAttachment={handleRemoveAttachment}
            onAddAttachment={handleAddAttachment}
        />
    );
}
